import convert from 'convert-seconds'
export default {
  methods: {
    convertDaysToSeconds (days) {
      return days * 60 * 60 * 24
    },
    convertSeconds (s) {
      return `${Math.floor(convert(s).hours / 24)} ${this.$i18n.t('day')}`
    },
    convertSecondsToDays (s) {
      return `${Math.floor(convert(s).hours / 24)}`
    }
  }
}
